var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { BaseLogger } from './base-logger';
import { consoleLogClient } from './console-client';
// import { EventLogger } from './event-logger';
import { LogAction } from './type';
function resolveClients(clients, disableConsole) {
    const result = clients.includes(consoleLogClient)
        ? clients
        : [consoleLogClient, ...clients];
    if (disableConsole) {
        return result.filter((item) => item !== consoleLogClient);
    }
    return result;
}
export class Logger extends BaseLogger {
    constructor(_a = {}) {
        var { clients = [] } = _a, rest = __rest(_a, ["clients"]);
        super(Object.assign(Object.assign({}, rest), { clients: resolveClients(clients, rest.disableConsole) }));
        // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/typedef
        this.persist = super.createLoggerWith({
            ctx: {
                action: [LogAction.CONSOLE, LogAction.PERSIST],
            },
        });
    }
    createLoggerWith(options) {
        return new Logger(this.resolveCloneParams(options));
    }
}
// API 测试
// const logger = new Logger()
// console.log('test', logger);
// logger.info('hello world');
// logger.info({ namespace: 'namespace', scope: 'scope', message: 'message' });
// logger.info({
//   namespace: 'namespace',
//   scope: 'scope',
//   message: 'message',
//   meta: { custom: 'xx' },
// });
// logger.persist.info({ message: '测试上报日志' });
// logger.persist.info({
//   message: '测试上报事件',
//   eventName: 'test_single_event',
// });
// const testEvent = logger.createEvent('test_event', {
//   meta: { custom: 'xx' },
// });
// testEvent.start({ meta: { custom: 'xx in start' } });
// testEvent.success();
// testEvent.fail({ error: new Error('test') });
// testEvent.cancel();
// testEvent.custom.info({ eventName: 'custom_event' });
// testEvent.auto(async () => {
//   console.log('do something')
// })
// 测试 createLoggerWith 类型，TODO：写单测
// const logger = new Logger();
// const childLogger = logger.createLoggerWith({
//   ctx: {
//     namespace: 'child',
//   },
// });
// const testEventCustom = logger.createEvent('test_event', {
//   meta: { custom: 'xx' },
// }).custom;
